import { useState } from 'react';
import DC from '../../../common/DataConnector';
import Helpers from '../../../common/Helpers';
import { i18n } from '../../../lang/i18n';
import { credentialSave } from '../../../store/UserData/UserData';
import { APIUrl } from '../../../common/Conf';
import ScrollToTop from '../../../components/ScrollToTop';
import { actAlertShow } from '../../../store/Actions';
import { useAppDispatch } from '../../../store/hooks';

export default function UserLoginScreen()
{
    const dispatch = useAppDispatch()
	const [step, setStep] = useState(0);
	const [email, setEmail] = useState('');
	const [emailError, setEmailError] = useState(false);
	const [emailCode, setEmailCode] = useState<string>('');

	async function step01_sendEmail()
	{
		if (Helpers.FormValidateEmail(email)) {
			setEmailError(false)
			const result = await DC.Post('/customer/login-start', { email: email });
			if (result.wasOk) {
				setStep(1)
			} else {
				actAlertShow(dispatch, 'danger', i18n._Labels.InternalError, 3);
			}
		}
		else {
			setEmailError(true)
		}
	}

	async function step02_sendCode()
	{

		if (emailCode.length > 4) {
			setEmailError(false)
			const result = await DC.Post('/customer/login-end', { email: email, code: emailCode });
			if (result.wasOk) {
				if (result.data.token && result.data.token.length > 11)
					credentialSave(result.data.token, dispatch)
				else if (result.data === 'error_date') {
					setStep(0)
					actAlertShow(dispatch, 'danger', i18n.CustomerLogin.LoginErrorDate, 3);
				} else {
					actAlertShow(dispatch, "danger", i18n.CustomerLogin.LoginErrorInfo, 3);
				}
			} else {
				actAlertShow(dispatch, "danger", i18n.CustomerLogin.LoginErrorInfo, 3);
			}
		}
		else {
			actAlertShow(dispatch, "danger", i18n.CustomerLogin.LoginErrorInfo, 3);
		}
	}
	function onCodeChange(e: any)
	{
		let code = e.target.value
		setEmailCode(code);
		if (code && code.length === 5) {
			//Keyboard.dismiss()
		}
	}
	return (<div className='login'>
		<ScrollToTop />
		<div style={{ paddingTop: 30 }}>
			<h4 style={{ textAlign: 'center' }}>
				{i18n.CustomerLogin.Login}
			</h4>
		</div>
		<div style={{ paddingTop: 30 }}>
			<a className="btn btn-outline-dark w-100 " href={APIUrl + "/login/gs/home"} role="button" style={{ textTransform: "none", borderRadius: "16px" }}>
				<img width="20px" style={{ "marginBottom": "3px", marginRight: "5px", fontSize: "1.5em" }} alt={i18n.CustomerLogin.ContinueWithGoogle} 
				src="./icons/GoogleLogo.svg" />
				{i18n.CustomerLogin.ContinueWithGoogle}
			</a>
		</div>
		<div style={{ paddingTop: 30, textAlign: 'center' }}>
			<p>ó</p>
		</div>
		<div style={{ paddingTop: 10 }}>
			<h4 style={{ textAlign: 'center' }}>
				{i18n.CustomerLogin.RegisterWithEmail}
			</h4>
		</div>
		{step === 0 && <div style={{ flexDirection: 'column', paddingTop: 20, marginBottom: 40, textAlign: 'center' }}>

			<div className="input-group">
				<div className="input-group-prepend">
					<span className="input-group-text" id="inputGroupPrepend2">@</span>
				</div><input className="form-control"
					placeholder="Email."
					onChange={(e) => setEmail(e.target.value)}
					value={email}
					type='email'
					autoCapitalize='none'
					maxLength={150}
				/>
			</div>
			{emailError &&
				<div style={{
					textAlign: 'center', color: 'red', backgroundColor: '#ffa5007a', marginBottom: 10, marginTop: 10, padding: 5,
					borderRadius: 5
				}}>
					{i18n.CustomerLogin.ErrorEmail}
				</div>}
			<div style={{ textAlign: 'center', marginBottom: 20, marginTop: 20 }}>
				{i18n.CustomerLogin.AcceptContinuaInfo}
			</div>
			<button className="btn btn-warning btn-main" onClick={step01_sendEmail} style={{ minWidth: 300 }}
			>{i18n.CustomerLogin.Continue}</button>
		</div>}
		{step === 1 && <div style={{ flexDirection: 'column', marginBottom: 40, textAlign: 'center' }}>
			<div style={{ textAlign: 'center', fontWeight: 'bold', marginTop: 20 }}>{i18n.CustomerLogin.Email}: {email}</div>
			<div style={{ textAlign: 'center' }}>
				{i18n.CustomerLogin.CodeSent01}
			</div>
			<div style={{ textAlign: 'center' }}>
				{i18n.CustomerLogin.CodeSent02}
			</div>
			<div style={{ textAlign: 'center', marginBottom: 15 }}>
				{i18n.CustomerLogin.CodeSent03}
			</div>
			<input className="form-control" placeholder={i18n.CustomerLogin.CodePlaceholder} type="number"
				onChange={onCodeChange} style={{ maxWidth: 300, margin: 'auto' }}
				value={emailCode}
				maxLength={5}
			/>
			<div style={{ padding: 20, paddingBottom: 5 }}>
				<button className="btn btn-warning btn-pay-cart" style={{ minWidth: 300 }}
					onClick={step02_sendCode}
				>{i18n.CustomerLogin.Login}</button>
			</div>
			<div style={{ padding: 20, paddingBottom: 5, paddingTop: 40 }}>
				<button className="btn btn-secondary btn-pay-cart" style={{ minWidth: 300 }}
					onClick={() => { setStep(0) }}
				>{i18n.CustomerLogin.Cancel}</button>
			</div>
		</div>}
	</div>
	);
}